import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import EditorJ from "@gull/components/Jodit/EditorJ";
import HtmlVariablesPanel from "./HtmlVariablesPanel";

const EditorHtmlModal = ({
    id,
    show,
    title,
    content,
    onChange,
    onClose,
    size = "xl",
    adattaStyle = false,
    nascondiSalva = true,
    variables,
    variablesLoading = false,
    variablesError = "",
    variablesCollapsible = false,
    onApply,
    onCancel,
}) => {
    const [showVariables, setShowVariables] = useState(false);
    const hasVariablesPanel = Array.isArray(variables);
    const isVariablesPanelVisible = hasVariablesPanel && (!variablesCollapsible || showVariables);
    const handleCancel = onCancel || onClose;

    useEffect(() => {
        if (show && variablesCollapsible) {
            setShowVariables(false);
        }
    }, [show, variablesCollapsible]);

    return (
        <Modal
            id={id}
            show={show}
            size={size}
            centered
            onHide={handleCancel}
            backdrop="static"
        >
            <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h5 className="text-white mb-0">{title}</h5>

                <i
                    className="i-Close-Window cursor-pointer text-18"
                    onClick={handleCancel}
                ></i>
            </Modal.Header>

            <Modal.Body>
                {hasVariablesPanel && variablesCollapsible && (
                    <div className="d-flex justify-content-end mb-2">
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                            onClick={() => setShowVariables((current) => !current)}
                            aria-expanded={showVariables}
                            aria-controls={`${id}-variables-panel`}
                            title={showVariables ? "Nascondi variabili ambiente" : "Mostra variabili ambiente"}
                        >
                            <i className={showVariables ? "i-Close" : "i-Eye"}></i>
                            {showVariables ? "Nascondi variabili" : "Mostra variabili"}
                        </button>
                    </div>
                )}
                <div className="row g-3">
                    {isVariablesPanelVisible && (
                        <div id={`${id}-variables-panel`} className="col-12 col-lg-3">
                            <HtmlVariablesPanel
                                variables={variables}
                                loading={variablesLoading}
                                error={variablesError}
                            />
                        </div>
                    )}
                    <div className={isVariablesPanelVisible ? "col-12 col-lg-9" : "col-12"}>
                        <EditorJ
                            onChange={onChange}
                            content={content}
                            adattaStyle={adattaStyle}
                            nascondiSalva={nascondiSalva}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                {onApply ? (
                    <>
                        <button className="btn btn-secondary" type="button" onClick={handleCancel}>
                            Annulla
                        </button>
                        <button className="btn btn-primary" type="button" onClick={onApply}>
                            Applica
                        </button>
                    </>
                ) : (
                    <button className="btn btn-primary" type="button" onClick={onClose}>
                        Chiudi
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EditorHtmlModal;
